export enum TripStatusEnum {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Dispatched = 'Dispatched',
  NewTrip = 'NewTrip',
  Returning = 'Returning',
  Assigned = 'Assigned',
}
